export default __webpack_public_path__ + "static/media/NC_1400x381.98c47479.png";